import React from "react";
import { Plus, X } from "lucide-react";

interface OverviewModalProps {
  title: string;

  addButtonLabel: string;

  children: React.ReactNode;

  onAction: () => void;

  onClose: () => void;
}

const OverviewModal: React.FC<
  OverviewModalProps
> = ({
  title,
  addButtonLabel,
  children,
  onAction,
  onClose,
}) => {
  return (
    <div
      className="
        fixed inset-0 z-50
        flex items-center justify-center
        bg-[rgba(10,10,10,0.20)]
      "
    >
      <div
        className="
          flex flex-col

          w-[608px]
          max-h-[65vh]

          rounded-[10px]
          border border-[#E5E5E5]
          bg-white
          p-6

          shadow-[
            0_10px_15px_-3px_rgba(0,0,0,0.10),
            0_4px_6px_-4px_rgba(0,0,0,0.10)
          ]
        "
      >
        <div className="shrink-0">
          <div className="flex items-center justify-between">
            <h2
              className="
                text-[18px]
                font-semibold
                leading-[18px]
                text-[#0A0A0A]
              "
            >
              {title}
            </h2>

            <div className="flex items-center gap-6">
              <button
                onClick={onAction}
                className="
                  flex items-center
                  gap-2
                  text-[14px]
                  font-medium
                  leading-5
                  text-[#3551F3]
                "
              >
                <Plus size={16} />

                <span>{addButtonLabel}</span>
              </button>

              <button
                onClick={onClose}
                className="
                  flex items-center
                  justify-center
                  text-[#0A0A0A]
                  opacity-70
                "
              >
                <X size={16} />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-6 min-h-0 flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default OverviewModal;